import { STab, SRowContainers, SIcon } from './SidebarElement.styles';
import Arrow from '../../assets/icons/chevron-right.svg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const defaultArrowIcon = (
  <SIcon height={20} className="arrow" src={Arrow} alt="" role="arrowIcon" />
);

export type SidebarSection = {
  name?: string;
  nameTx?: string;
  e2eId?: string;
  icon: string;
  rightIcon?: JSX.Element;
  to?: string;
  target?: string;
  onClick?: () => void;
};

function SidebarElement(props: SidebarSection) {
  const { name, nameTx, icon, rightIcon, to, target, onClick, e2eId } = props;
  const { t } = useTranslation();

  const translatedName = nameTx ? t(`${nameTx}`) : name;

  if (to) {
    return (
      <STab as={Link} to={to} target={target} data-testid={`elementContainer-${e2eId}`}>
        <SRowContainers role="content">
          <SIcon className="icon" src={icon} alt="" role="elementIcon" />
          {translatedName}
        </SRowContainers>
        {rightIcon}
      </STab>
    );
  } else {
    return (
      <STab onClick={onClick} role={`elementContainer-${e2eId}`}>
        <SRowContainers role="content">
          <SIcon className="icon" src={icon} alt="" data-testid={`elementContainer-${e2eId}`} />
          {translatedName}
        </SRowContainers>
        {rightIcon}
      </STab>
    );
  }
}

export default SidebarElement;
